import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgCompany(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.3273 2.11824C14.6298 1.65293 16 2.61881 16 4.00229V7.99578H20C21.1046 7.99578 22 8.89148 22 9.99638V19.9994C22 21.1043 21.1046 22 20 22L4 22C2.89543 22 2 21.1043 2 19.9994V7.5748C2 6.72932 2.53134 5.97511 3.32733 5.69075L13.3273 2.11824ZM20 19.9994V9.99638H16V11.997H18V13.9976H16V15.9982H18V17.9988H16V19.9994H20ZM8 15.9982H6V17.9988H8V15.9982ZM10 15.9982H12V17.9988H10V15.9982ZM8 11.997H6V13.9976H8V11.997ZM10 11.997H12V13.9976H10V11.997ZM12 7.99578H10V9.99638H12V7.99578ZM6 7.99578H8V9.99638H6V7.99578Z", fill: "currentColor" })));
}
export default SvgCompany;
